/// <reference path="../../../Scripts/jquery-1.10.2.min.js" />
/// <reference path="../ui.core.js" />
/// <reference path="../jquery-ui-1.10.4.min.js" />
/// <reference path="../jquery.blockUI.js" />

//function Apple(type) {
//    this.type = type;
//    this.color = "red";
//    this.getInfo = function () {
//        return this.color + ' ' + this.type + ' apple';
//    };
//}

$(document).ready(function () {
    Translate_InitDialog();
});

Translate_InitDialog = function () {
    var $dialog = $('<div></div>');
    $('.translateDialog a').click(function () {
        var $link = $(this);
        $dialog
				.empty()
				.append($loading.clone())
				.dialog({
				    title: $link.attr('title'),
				    modal: true,
                    position: top,
				    buttons: {
				        'Update': function () { Translate_Update($(this).find('form'), $dialog); },
				        'Close': function () { $(this).dialog('close'); }
				    },
				    close: function () { $(this).closest(); },
				    width: '800px',
                    height: 600
				});

				$dialog
					.load($link.attr('href'), function (response, status, xhr) {
					    if (status == "error") {
					        $.blockUI({
					            message: xhr.status + ' ' + xhr.statusText + '\n\n' + response,
					            centerY: false,
					            centerX: false
					        });
					    }
					    else {
					        // It seems jQuery 1.4.1 & 1.4.2 has a problem in IE with .text() on script nodes… so do the loop ourselves…
					        // execute the js that was loadad by ajax
					        var scripts = $dialog.find("script");
					        var allScriptText = "";
					        for (var i = 0; i < scripts.length; i++) {
					            allScriptText += scripts[i].text;
					        }
					        jQuery.globalEval(allScriptText);
					        $(this).dialog('option', 'position', 'center') //recenter the dialog
					    }
					})
					.dialog('open');
				return false;
    });
}

Translate_Update = function (form, dialog) {
    form = $(form);
    $.ajax({
        url: form.attr('action'),
        data: form.serialize(),
        type: (form.attr('method')),
        success: function (data, message) {
            dialog.dialog('close');
            $.blockUI({ message: '<h1>Changes saved!\n<br>Page is reloading, please wait!</h1>' });
            setTimeout(function () { location.reload(); }, 1000);
        },
        error: function (data) {
            $.blockUI({
                message: data.ResponseText,
                centerY: false,
                centerX: false
            });
        },
        dataType: 'json'
    });
    return false;
}